/* Copyright (C) 2022 ev-i Informationstechnologie GmbH */

export enum ManualNotFoundResolution {
    LABEL_IGNORED = "LABEL_IGNORED",
    RENDER_LABEL_OUTSIDE_OF_PLAN = "RENDER_LABEL_OUTSIDE_OF_PLAN",
    RENDER_LABEL_AS_IS = "RENDER_LABEL_AS_IS"
}

export default ManualNotFoundResolution;
